import s from "./extends3.mjs";
const t = (e) => {
  if (e !== void 0)
    return Object.keys(e).reduce((r, n) => s({}, r, {
      [`${n.slice(0, 1).toLowerCase()}${n.slice(1)}`]: e[n]
    }), {});
};
export {
  t as uncapitalizeObjectKeys
};
//# sourceMappingURL=slots-migration.mjs.map
